import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import ProgramHoliday from '../pages/program/holiday';
import ProgramConvert from '../pages/program/convert';
import ProgramConvertCreate from '../pages/program/convert/create';
import ProgramConvertEdit from '../pages/program/convert/edit';
import ProgramConvertTable from '../pages/program/convert/table';
import ProgramConvertTableCreate from '../pages/program/convert/table/create';
import ProgramConvertTableEdit from '../pages/program/convert/table/edit';
import ProgramCriteria from '../pages/program/criteria';
import ProgramCriteriaSub from '../pages/program/criteria/sub';
import ProgramCriteriaActivity from '../pages/program/criteria/activity';
import ProgramStep from '../pages/program/step';
import ProgramStepCreate from '../pages/program/step/create';
import ProgramCourse from '../pages/program/course';
import ProgramCourseCreate from '../pages/program/course/create';
import ProgramCourseEdit from '../pages/program/course/edit';
import ProgramSemester from '../pages/program/semester';
import ProgramAward from '../pages/program/award';
import ProgramAwardCreate from '../pages/program/award/create';
import ProgramAwardRead from '../pages/program/award/read';
import ProgramAwardEdit from '../pages/program/award/edit';
import ProgramSemester2 from '../pages/program/semester2';
import OverlappingSemester from '../pages/program/overlapping-semester';
import ProgramPoint from '../pages/program/point';

const ProgramRouter: FC = () => {
  return (
    <Switch>
      <Route path="/program/holiday" exact component={ProgramHoliday} />
      <Route path="/program/convert" exact component={ProgramConvert} />
      <Route
        path="/program/convert/create"
        exact
        component={ProgramConvertCreate}
      />
      <Route
        path="/program/convert/:id/edit"
        exact
        component={ProgramConvertEdit}
      />
      <Route
        path="/program/convert/:id/table"
        exact
        component={ProgramConvertTable}
      />
      <Route
        path="/program/convert/:id/table/create"
        exact
        component={ProgramConvertTableCreate}
      />
      <Route
        path="/program/convert/:topId/table/:subId/edit"
        exact
        component={ProgramConvertTableEdit}
      />
      <Route path="/program/criteria" exact component={ProgramCriteria} />
      <Route
        path="/program/criteria/:id/sub"
        exact
        component={ProgramCriteriaSub}
      />
      <Route
        path="/program/criteria/:id/activity"
        exact
        component={ProgramCriteriaActivity}
      />
      <Route path="/program/step" exact component={ProgramStep} />
      <Route
        path="/program/step/:id/create"
        exact
        component={ProgramStepCreate}
      />
      <Route path="/program/course" exact component={ProgramCourse} />
      <Route
        path="/program/course/create"
        exact
        component={ProgramCourseCreate}
      />
      <Route
        path="/program/course/:id/edit"
        exact
        component={ProgramCourseEdit}
      />
      <Route path="/program/semester" exact component={ProgramSemester} />
      <Route path="/program/award" exact component={ProgramAward} />
      <Route
        path="/program/award/create"
        exact
        component={ProgramAwardCreate}
      />
      <Route
        path="/program/award/:awardCode"
        exact
        component={ProgramAwardRead}
      />
      <Route
        path="/program/award/:awardCode/edit"
        exact
        component={ProgramAwardEdit}
      />
      <Route path="/program/point" exact component={ProgramPoint} />
      <Route path="/program/semester2" exact component={ProgramSemester2} />
      <Route path="/program/overlapping-semester" exact component={OverlappingSemester} />
    </Switch>
  );
};

export default ProgramRouter;
